import React from 'react';
import Input from "../../../../components/Input";
import cx from 'classnames';
import styles from './EmailTab.module.scss';

interface EmailTabProps {
    config: {
        receiverEmail?: string;
        bccEmail?: string;
        emailSubject: string;
        successMessage: string;
        errorMessage: string;
    };
    updateConfig: (property: string, value: any) => void;
}

const EmailTab: React.FC<EmailTabProps> = ({ config, updateConfig }) => {
    return (
        <div className={cx(styles.container)}>
            <div className={cx(styles['info-box'], 'zr-mb-3')}>
                <p>
                    Konfigurieren Sie die E-Mail-Einstellungen für das Kontaktformular.
                </p>
            </div>
            
            <div className="zr-mb-4">
                <Input
                    type="email"
                    property="receiverEmail"
                    value={config.receiverEmail || ''}
                    onChange={updateConfig}
                    placeholder="Empfänger E-Mail Adresse"
                />
                <small className="form-text text-muted">
                    Wenn dieses Feld leer ist, wird die E-Mail an den Email Master von JTL shop gesendet.
                </small>
            </div>
            
            <div className="zr-mb-4">
                <Input
                    type="email"
                    property="bccEmail"
                    value={config.bccEmail || ''}
                    onChange={updateConfig}
                    placeholder="BCC E-Mail Adressen (durch Komma getrennt)"
                />
            </div>
            
            <div className="zr-mb-4">
                <Input
                    type="text"
                    property="emailSubject"
                    value={config.emailSubject}
                    onChange={updateConfig}
                    placeholder="E-Mail Betreff"
                />
            </div>
            
            <div className="zr-mb-4">
                <Input
                    type="textarea"
                    property="successMessage"
                    value={config.successMessage}
                    onChange={updateConfig}
                    placeholder="Erfolgsnachricht"
                />
            </div>
            
            <div className="zr-mb-4">
                <Input
                    type="textarea"
                    property="errorMessage"
                    value={config.errorMessage}
                    onChange={updateConfig}
                    placeholder="Fehlermeldung"
                />
            </div>
        </div>
    );
};

export default EmailTab; 